export default {
    white: '#ffffff',
    black: '#000000',

    red: '#C23616',
    yellow: "#FFC312",
    blue: "#4b7bec",

    lightGreen: '#A3CB38',
    green: '#6AB04C',

    veryLightGrey: '#ecf0f1',
    darkGrey: '#2F3640',

    error: "#C23616",
    success: "#6AB04C",
    info: "#4b7bec",
    warning: "#FFC312",

    headerShadow: "-1px -1px 5px 1px rgba(0,0,0,.05), 1px 1px 5px 1px rgba(0,0,0,.05)",
    buttonShadow: "-1px -1px 5px 1px rgba(0,0,0,.1), 1px 1px 5px 1px rgba(0,0,0,.1)",
    dropdownShadow: "-1px -1px 5px 1px rgba(0,0,0,.05), 1px 1px 5px 1px rgba(0,0,0,.05)",
    headerDropdownShadow: "0px 5px 5px 1px rgba(0,0,0,.05)",
    buttonHoverShadow: "-1px -1px 5px 1px rgba(0,0,0,.15), 1px 1px 5px 1px rgba(0,0,0,.15)",
    radioShadow: "-1px -1px 5px 1px rgba(0,0,0,.01), 1px 1px 5px 1px rgba(0,0,0,.01)",
}
